import { APP_VERSION, BUILD_TIMESTAMP, IS_PRODUCTION, IS_DEVELOPMENT } from '../config';

// Cache busting utility
export const cacheBuster = {
  version: APP_VERSION,
  timestamp: BUILD_TIMESTAMP,
  
  // Add version to URLs to force cache refresh
  addVersionToUrl: (url) => {
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}v=${APP_VERSION}&t=${BUILD_TIMESTAMP}`;
  },
  
  // Force reload of CSS/JS files
  forceReload: () => {
    if (IS_DEVELOPMENT) {
      console.log('🔄 Force reloading resources for cache busting');
      
      // Reload CSS files
      const links = document.querySelectorAll('link[rel="stylesheet"]');
      links.forEach(link => {
        const href = link.href;
        const newHref = cacheBuster.addVersionToUrl(href);
        if (href !== newHref) {
          link.href = newHref;
        }
      });
      
      // Reload JS files
      const scripts = document.querySelectorAll('script[src]');
      scripts.forEach(script => {
        const src = script.src;
        const newSrc = cacheBuster.addVersionToUrl(src);
        if (src !== newSrc) {
          script.src = newSrc;
        }
      });
    }
  },
  
  // Debug preferences functionality - ONLY for admins and creators
  debugPreferences: (userPreferences, showMutualGlow, hoveredPlayer, currentUserRole) => {
    // Only show debug info to admins and creators in development
    if (IS_DEVELOPMENT && (currentUserRole === 'admin' || currentUserRole === 'creator')) {
      console.group('🔍 Preferences Debug (Admin/Creator Only)');
      console.log('📦 App Version:', APP_VERSION);
      console.log('⏰ Build Timestamp:', BUILD_TIMESTAMP);
      console.log('🌍 Environment:', IS_PRODUCTION ? 'Production' : 'Development');
      console.log('✨ Show Mutual Glow:', showMutualGlow);
      console.log('🎯 Hovered Player:', hoveredPlayer?.username || hoveredPlayer?.user_id || 'None');
      console.log('👥 User Preferences Count:', Object.keys(userPreferences).length);
      console.log('📋 User Preferences Sample:', Object.keys(userPreferences).slice(0, 3));
      console.groupEnd();
    }
  },
  
  // Check if hover effects are working - ONLY for admins and creators
  testHoverEffects: (currentUserRole) => {
    // Only test hover effects for admins and creators in development
    if (IS_DEVELOPMENT && (currentUserRole === 'admin' || currentUserRole === 'creator')) {
      console.log('🧪 Testing hover effects...');
      
      // Test if CSS classes are available
      const testElement = document.createElement('div');
      testElement.className = 'preference-glow preference-hover';
      document.body.appendChild(testElement);
      
      const computedStyle = window.getComputedStyle(testElement);
      const hasGlow = computedStyle.boxShadow !== 'none';
      const hasTransition = computedStyle.transition !== 'all 0s ease 0s';
      
      console.log('✨ Glow effect available:', hasGlow);
      console.log('⏱️ Transition effect available:', hasTransition);
      
      document.body.removeChild(testElement);
      
      return { hasGlow, hasTransition };
    }
    return { hasGlow: true, hasTransition: true };
  }
};

export default cacheBuster; 